import { render, staticRenderFns } from "./ProductBuyWidget.vue?vue&type=template&id=a67df3aa&scoped=true&"
import script from "./ProductBuyWidget.vue?vue&type=script&lang=ts&"
export * from "./ProductBuyWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ProductBuyWidget.vue?vue&type=style&index=0&id=a67df3aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67df3aa",
  null
  
)

export default component.exports